import { createStyles } from 'antd-style';

import { ThemeFont, ThemeSpaces } from '../theme';
import { reportsDialogSection } from '../widgets/reports/reportsShared.styles';

export const useReportsDialogStyles = createStyles(({ token }) => ({
  // `&&` outranks SimpleDialog.styles.js's base `.ant-modal-content`/
  // `.ant-modal-body`/typography rules (equal specificity otherwise, since
  // both are applied directly to the same Modal).
  reportsDialog: {
    '.ant-modal-content': {
      [`@media (min-width: ${token.screenLGMin}px)`]: {
        width: '800px',
      },
      [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          width: '500px',
        },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        width: '320px',
      },
    },

    '.ant-modal-body': {
      alignItems: 'stretch',

      [`@media (min-width: ${token.screenLGMin}px)`]: {
        padding: `${ThemeSpaces.SPACE_XL}px ${ThemeSpaces.SPACE_NORM_60}px`,
      },
      [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          padding: `${ThemeSpaces.SPACE_NORM_15}px ${ThemeSpaces.SPACE_NORM_20}px`,
        },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        padding: ThemeSpaces.SPACE_NORM,
      },

      'h2.ant-typography': {
        fontSize: ThemeFont.FONT_SIZE_30,
        marginBottom: 0,
      },
      'h4.ant-typography': {
        fontWeight: 300,
        marginBottom: ThemeSpaces.SPACE_NORM_20,
        textAlign: 'center',
      },
    },

    '.SimpleDialog-Icon': {
      '> img': {
        width: 56,
        height: 59,
      },
      '&::before': {
        display: 'none',
      },
    },

    form: {
      marginBottom: 0,
    },
  },

  // Reuses reportsShared.styles.js's `.ReportsDialog__Section` base (also
  // rendered directly by ReportsDateRange/ReportsDownloadSummary/
  // ReportsSelectionSection) plus its own layout overrides.
  toolbar: {
    ...reportsDialogSection(token),
    height: 70,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: ThemeSpaces.SPACE_NORM,
    paddingTop: 0,
    paddingBottom: 0,
    borderWidth: 2,
  },
}));
